import React, { createContext, useContext, useState } from 'react';
import CartSelector from '../components/CartSelector';


const CartSelectorContext = createContext();

export const useCartSelector = () => useContext(CartSelectorContext);

export const CartSelectorProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedQuantity, setSelectedQuantity] = useState(1);
  const [storeName,setStoreName] = useState("")
  

  const openCartSelector = (product, quantity = 1,name) => {

    setSelectedProduct(product);
    setSelectedQuantity(quantity);
    setStoreName(name);
    setIsOpen(true);
  };

  const closeCartSelector = () => setIsOpen(false);

  return (
    <CartSelectorContext.Provider
      value={{
        openCartSelector,
        closeCartSelector,
        selectedProduct,
        selectedQuantity,
        storeName,
        setSelectedQuantity,
      }}
    >
      {children}
      <CartSelector
        isOpen={isOpen}
        onClose={closeCartSelector}
        selectedProduct={selectedProduct}
        selectedQuantity={selectedQuantity}
        storeName={storeName}
      />
    </CartSelectorContext.Provider>
  );
};
